module.exports = __webpack_public_path__ + "static/img/publicAc.65c33d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/publicAc.png
// module id = Hcg5
// module chunks = 5